<script lang="ts">
  export let theme: string | null;
</script>

<svg
  width="100%"
  height="100%"
  viewBox="0 0 375 809"
  fill="none"
  preserveAspectRatio="none"
  xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_1179_3871)">
    <rect width="375" height="809" fill={theme === "light" ? "#F4F2F7" : "#131019"} />
    <g filter="url(#filter0_f_1179_3871)">
      <ellipse
        cx="187.5"
        cy="804.653"
        rx="187.5"
        ry="304.181"
        fill="hsl(var(--color-accent))"
        fill-opacity="0.16" />
    </g>
    <mask
      id="mask0_1179_3871"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="26"
      y="343"
      width="323"
      height="456">
      <path
        d="M26.7515 798.506L348.249 798.506L348.249 366.432L319.311 343.5L26.7515 343.5L26.7515 798.506Z"
        fill="url(#paint0_linear_1179_3871)" />
    </mask>
    <g mask="url(#mask0_1179_3871)">
      <g opacity="0.6">
        <path
          d="M329.407 560.531C329.836 560.531 330.183 560.876 330.183 561.302C330.183 561.728 329.836 562.073 329.407 562.073C328.978 562.073 328.631 561.728 328.631 561.302C328.631 560.876 328.978 560.531 329.407 560.531Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M340.979 656.453C341.408 656.453 341.755 656.798 341.755 657.224C341.755 657.649 341.408 657.995 340.979 657.995C340.551 657.995 340.203 657.649 340.203 657.224C340.203 656.798 340.551 656.453 340.979 656.453Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M332.574 646.015C333.002 646.015 333.35 646.36 333.35 646.786C333.35 647.211 333.002 647.557 332.574 647.557C332.145 647.557 331.798 647.211 331.798 646.786C331.798 646.36 332.145 646.015 332.574 646.015Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M304.824 592.606C305.253 592.606 305.6 592.951 305.6 593.377C305.6 593.803 305.253 594.148 304.824 594.148C304.395 594.148 304.048 593.803 304.048 593.377C304.048 592.951 304.395 592.606 304.824 592.606Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M328.618 584.139C329.046 584.139 329.394 584.484 329.394 584.91C329.394 585.335 329.046 585.681 328.618 585.681C328.189 585.681 327.841 585.335 327.841 584.91C327.841 584.484 328.189 584.139 328.618 584.139Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M248.774 516.411C249.344 516.411 249.806 516.871 249.806 517.437C249.806 518.003 249.344 518.462 248.774 518.462C248.204 518.462 247.742 518.003 247.742 517.437C247.742 516.871 248.204 516.411 248.774 516.411Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M211.396 456.255C211.828 456.255 212.179 456.604 212.179 457.034C212.179 457.464 211.828 457.813 211.396 457.813C210.963 457.813 210.612 457.464 210.612 457.034C210.612 456.604 210.963 456.255 211.396 456.255Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M280.429 419.331C280.858 419.331 281.206 419.676 281.206 420.102C281.206 420.528 280.858 420.873 280.429 420.873C280.001 420.873 279.653 420.528 279.653 420.102C279.653 419.676 280.001 419.331 280.429 419.331Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M196.612 471.791C197.05 471.791 197.404 472.143 197.404 472.577C197.404 473.012 197.05 473.364 196.612 473.364C196.175 473.364 195.821 473.012 195.821 472.577C195.821 472.143 196.175 471.791 196.612 471.791Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M150.762 490.149C151.19 490.149 151.538 490.495 151.538 490.92C151.538 491.346 151.19 491.691 150.762 491.691C150.333 491.691 149.985 491.346 149.985 490.92C149.985 490.495 150.333 490.149 150.762 490.149Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M108.496 528.191C108.924 528.191 109.272 528.537 109.272 528.962C109.272 529.388 108.924 529.733 108.496 529.733C108.067 529.733 107.72 529.388 107.72 528.962C107.72 528.537 108.067 528.191 108.496 528.191Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M127.479 544.007C127.946 544.007 128.325 544.383 128.325 544.848C128.325 545.312 127.946 545.688 127.479 545.688C127.011 545.688 126.633 545.312 126.633 544.848C126.633 544.383 127.011 544.007 127.479 544.007Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M237.528 579.274C238.042 579.274 238.459 579.688 238.459 580.199C238.459 580.71 238.042 581.124 237.528 581.124C237.013 581.124 236.596 580.71 236.596 580.199C236.596 579.688 237.013 579.274 237.528 579.274Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M209.316 608.751C209.796 608.751 210.186 609.138 210.186 609.614C210.186 610.091 209.796 610.478 209.316 610.478C208.836 610.478 208.447 610.091 208.447 609.614C208.447 609.138 208.836 608.751 209.316 608.751Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M203.739 622.042C204.198 622.042 204.57 622.412 204.57 622.867C204.57 623.323 204.198 623.692 203.739 623.692C203.28 623.692 202.908 623.323 202.908 622.867C202.908 622.412 203.28 622.042 203.739 622.042Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M146.617 548.131C147.127 548.131 147.54 548.542 147.54 549.048C147.54 549.555 147.127 549.966 146.617 549.966C146.107 549.966 145.693 549.555 145.693 549.048C145.693 548.542 146.107 548.131 146.617 548.131Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M117.249 503.719C117.677 503.719 118.025 504.064 118.025 504.49C118.025 504.916 117.677 505.261 117.249 505.261C116.82 505.261 116.472 504.916 116.472 504.49C116.472 504.064 116.82 503.719 117.249 503.719Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M151.197 410.101C151.626 410.101 151.973 410.446 151.973 410.872C151.973 411.298 151.626 411.643 151.197 411.643C150.769 411.643 150.421 411.298 150.421 410.872C150.421 410.446 150.769 410.101 151.197 410.101Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M117.413 412.623C117.841 412.623 118.189 412.968 118.189 413.394C118.189 413.82 117.841 414.165 117.413 414.165C116.984 414.165 116.637 413.82 116.637 413.394C116.637 412.968 116.984 412.623 117.413 412.623Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M162.853 398.543C163.282 398.543 163.629 398.889 163.629 399.314C163.629 399.74 163.282 400.085 162.853 400.085C162.425 400.085 162.077 399.74 162.077 399.314C162.077 398.889 162.425 398.543 162.853 398.543Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M78.0571 605.503C78.533 605.503 78.9187 605.886 78.9187 606.358C78.9187 606.831 78.533 607.214 78.0571 607.214C77.5813 607.214 77.1956 606.831 77.1956 606.358C77.1956 605.886 77.5813 605.503 78.0571 605.503Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M112.384 561.37C112.852 561.37 113.231 561.747 113.231 562.211C113.231 562.675 112.852 563.051 112.384 563.051C111.917 563.051 111.538 562.675 111.538 562.211C111.538 561.747 111.917 561.37 112.384 561.37Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M316.007 562.756C316.44 562.756 316.791 563.105 316.791 563.535C316.791 563.965 316.44 564.313 316.007 564.313C315.574 564.313 315.223 563.965 315.223 563.535C315.223 563.105 315.574 562.756 316.007 562.756Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M82.5211 597.802C82.9927 597.802 83.3749 598.182 83.3749 598.65C83.3749 599.119 82.9927 599.499 82.5211 599.499C82.0496 599.499 81.6673 599.119 81.6673 598.65C81.6673 598.182 82.0496 597.802 82.5211 597.802Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M81.0074 449.069C81.4361 449.069 81.7836 449.414 81.7836 449.84C81.7836 450.266 81.4361 450.611 81.0074 450.611C80.5788 450.611 80.2313 450.266 80.2313 449.84C80.2313 449.414 80.5788 449.069 81.0074 449.069Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M99.8648 786.142C100.293 786.142 100.641 786.487 100.641 786.913C100.641 787.339 100.293 787.684 99.8648 787.684C99.4361 787.684 99.0886 787.339 99.0886 786.913C99.0886 786.487 99.4361 786.142 99.8648 786.142Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M144.529 766.843C144.958 766.843 145.305 767.188 145.305 767.614C145.305 768.04 144.958 768.385 144.529 768.385C144.101 768.385 143.753 768.04 143.753 767.614C143.753 767.188 144.101 766.843 144.529 766.843Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M152.143 685.49C152.571 685.49 152.919 685.835 152.919 686.261C152.919 686.687 152.571 687.032 152.143 687.032C151.714 687.032 151.366 686.687 151.366 686.261C151.366 685.835 151.714 685.49 152.143 685.49Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M81.726 690.582C82.1547 690.582 82.5022 690.927 82.5022 691.353C82.5022 691.779 82.1547 692.124 81.726 692.124C81.2973 692.124 80.9498 691.779 80.9498 691.353C80.9498 690.927 81.2973 690.582 81.726 690.582Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M130.737 668.644C131.166 668.644 131.514 668.989 131.514 669.415C131.514 669.841 131.166 670.186 130.737 670.186C130.309 670.186 129.961 669.841 129.961 669.415C129.961 668.989 130.309 668.644 130.737 668.644Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M293.491 782.635C293.928 782.635 294.282 782.987 294.282 783.421C294.282 783.855 293.928 784.208 293.491 784.208C293.053 784.208 292.699 783.855 292.699 783.421C292.699 782.987 293.053 782.635 293.491 782.635Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M247.951 768.656C248.418 768.656 248.797 769.032 248.797 769.496C248.797 769.96 248.418 770.336 247.951 770.336C247.483 770.336 247.105 769.96 247.105 769.496C247.105 769.032 247.483 768.656 247.951 768.656Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M301.478 744.128C301.907 744.128 302.254 744.474 302.254 744.899C302.254 745.325 301.907 745.67 301.478 745.67C301.049 745.67 300.702 745.325 300.702 744.899C300.702 744.474 301.049 744.128 301.478 744.128Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M324.238 706.61C324.666 706.61 325.014 706.955 325.014 707.381C325.014 707.807 324.666 708.152 324.238 708.152C323.809 708.152 323.461 707.807 323.461 707.381C323.461 706.955 323.809 706.61 324.238 706.61Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M134.58 711.937C135.009 711.937 135.356 712.282 135.356 712.708C135.356 713.134 135.009 713.479 134.58 713.479C134.151 713.479 133.804 713.134 133.804 712.708C133.804 712.282 134.151 711.937 134.58 711.937Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M98.6934 659.114C99.1349 659.114 99.4928 659.469 99.4928 659.908C99.4928 660.347 99.1349 660.702 98.6934 660.702C98.2518 660.702 97.8939 660.347 97.8939 659.908C97.8939 659.469 98.2518 659.114 98.6934 659.114Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M97.862 739.278C98.2907 739.278 98.6382 739.623 98.6382 740.049C98.6382 740.475 98.2907 740.82 97.862 740.82C97.4333 740.82 97.0858 740.475 97.0858 740.049C97.0858 739.623 97.4333 739.278 97.862 739.278Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M143.504 447.204C143.937 447.204 144.288 447.552 144.288 447.982C144.288 448.413 143.937 448.761 143.504 448.761C143.071 448.761 142.72 448.413 142.72 447.982C142.72 447.552 143.071 447.204 143.504 447.204Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M115.738 596.83C116.209 596.83 116.592 597.21 116.592 597.678C116.592 598.147 116.209 598.526 115.738 598.526C115.266 598.526 114.884 598.147 114.884 597.678C114.884 597.21 115.266 596.83 115.738 596.83Z"
          fill="hsl(var(--color-accent))" />
      </g>
      <g filter="url(#filter1_f_1179_3871)">
        <path
          d="M267.281 485.82C267.627 485.82 267.907 486.114 267.907 486.476C267.907 486.838 267.627 487.131 267.281 487.131C266.936 487.131 266.656 486.838 266.656 486.476C266.656 486.114 266.936 485.82 267.281 485.82Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M221.805 521.385C222.164 521.385 222.455 521.69 222.455 522.066C222.455 522.442 222.164 522.748 221.805 522.748C221.445 522.748 221.154 522.442 221.154 522.066C221.154 521.69 221.445 521.385 221.805 521.385Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M281.807 512.194C282.16 512.194 282.445 512.493 282.445 512.862C282.445 513.232 282.16 513.531 281.807 513.531C281.455 513.531 281.169 513.232 281.169 512.862C281.169 512.493 281.455 512.194 281.807 512.194Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M343.543 561.366C343.885 561.366 344.163 561.657 344.163 562.015C344.163 562.374 343.885 562.664 343.543 562.664C343.201 562.664 342.923 562.374 342.923 562.015C342.923 561.657 343.201 561.366 343.543 561.366Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M315.721 589.96C316.064 589.96 316.341 590.25 316.341 590.609C316.341 590.967 316.064 591.258 315.721 591.258C315.379 591.258 315.102 590.967 315.102 590.609C315.102 590.25 315.379 589.96 315.721 589.96Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M335.129 607.671C335.471 607.671 335.749 607.962 335.749 608.32C335.749 608.679 335.471 608.969 335.129 608.969C334.787 608.969 334.509 608.679 334.509 608.32C334.509 607.962 334.787 607.671 335.129 607.671Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M209.946 628.188C210.288 628.188 210.566 628.479 210.566 628.837C210.566 629.196 210.288 629.486 209.946 629.486C209.604 629.486 209.326 629.196 209.326 628.837C209.326 628.479 209.604 628.188 209.946 628.188Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M218.946 614.296C219.288 614.296 219.565 614.586 219.565 614.945C219.565 615.303 219.288 615.594 218.946 615.594C218.603 615.594 218.326 615.303 218.326 614.945C218.326 614.586 218.603 614.296 218.946 614.296Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M217.606 562.666C217.948 562.666 218.226 562.956 218.226 563.315C218.226 563.673 217.948 563.964 217.606 563.964C217.264 563.964 216.986 563.673 216.986 563.315C216.986 562.956 217.264 562.666 217.606 562.666Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M160.237 475.172C160.641 475.172 160.968 475.514 160.968 475.937C160.968 476.36 160.641 476.703 160.237 476.703C159.833 476.703 159.505 476.36 159.505 475.937C159.505 475.514 159.833 475.172 160.237 475.172Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M143.01 447.901C143.356 447.901 143.636 448.195 143.636 448.557C143.636 448.919 143.356 449.212 143.01 449.212C142.664 449.212 142.384 448.919 142.384 448.557C142.384 448.195 142.664 447.901 143.01 447.901Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M198.129 416.823C198.471 416.823 198.749 417.113 198.749 417.472C198.749 417.83 198.471 418.121 198.129 418.121C197.787 418.121 197.509 417.83 197.509 417.472C197.509 417.113 197.787 416.823 198.129 416.823Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M296.991 406.745C297.333 406.745 297.61 407.036 297.61 407.394C297.61 407.752 297.333 408.043 296.991 408.043C296.648 408.043 296.371 407.752 296.371 407.394C296.371 407.036 296.648 406.745 296.991 406.745Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M255.503 535.999C255.849 535.999 256.129 536.293 256.129 536.655C256.129 537.017 255.849 537.31 255.503 537.31C255.157 537.31 254.877 537.017 254.877 536.655C254.877 536.293 255.157 535.999 255.503 535.999Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M131.207 460.977C131.556 460.977 131.839 461.274 131.839 461.639C131.839 462.005 131.556 462.301 131.207 462.301C130.858 462.301 130.575 462.005 130.575 461.639C130.575 461.274 130.858 460.977 131.207 460.977Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M94.5981 476.43C94.9403 476.43 95.2178 476.721 95.2178 477.079C95.2178 477.437 94.9403 477.728 94.5981 477.728C94.2558 477.728 93.9783 477.437 93.9783 477.079C93.9783 476.721 94.2558 476.43 94.5981 476.43Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M93.4452 484.074C93.7978 484.074 94.0835 484.374 94.0835 484.743C94.0835 485.112 93.7978 485.411 93.4452 485.411C93.0927 485.411 92.8069 485.112 92.8069 484.743C92.8069 484.374 93.0927 484.074 93.4452 484.074Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M60.8522 508.45C61.1944 508.45 61.4719 508.74 61.4719 509.099C61.4719 509.457 61.1944 509.748 60.8522 509.748C60.5099 509.748 60.2324 509.457 60.2324 509.099C60.2324 508.74 60.5099 508.45 60.8522 508.45Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M80.614 548.315C80.9973 548.315 81.3081 548.64 81.3081 549.042C81.3081 549.443 80.9973 549.769 80.614 549.769C80.2306 549.769 79.9199 549.443 79.9199 549.042C79.9199 548.64 80.2306 548.315 80.614 548.315Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M163.875 551.445C164.285 551.445 164.618 551.794 164.618 552.224C164.618 552.654 164.285 553.002 163.875 553.002C163.464 553.002 163.131 552.654 163.131 552.224C163.131 551.794 163.464 551.445 163.875 551.445Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M141.351 576.254C141.734 576.254 142.045 576.579 142.045 576.981C142.045 577.382 141.734 577.708 141.351 577.708C140.968 577.708 140.657 577.382 140.657 576.981C140.657 576.579 140.968 576.254 141.351 576.254Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M67.8402 487.851C68.1825 487.851 68.46 488.142 68.46 488.5C68.46 488.859 68.1825 489.149 67.8402 489.149C67.498 489.149 67.2205 488.859 67.2205 488.5C67.2205 488.142 67.498 487.851 67.8402 487.851Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M67.9713 411.177C68.3136 411.177 68.591 411.468 68.591 411.826C68.591 412.185 68.3136 412.475 67.9713 412.475C67.629 412.475 67.3516 412.185 67.3516 411.826C67.3516 411.468 67.629 411.177 67.9713 411.177Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M36.5488 573.521C36.9287 573.521 37.2367 573.844 37.2367 574.242C37.2367 574.639 36.9287 574.962 36.5488 574.962C36.1689 574.962 35.8609 574.639 35.8609 574.242C35.8609 573.844 36.1689 573.521 36.5488 573.521Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M31.0892 564.742C31.4691 564.742 31.7771 565.064 31.7771 565.462C31.7771 565.86 31.4691 566.183 31.0892 566.183C30.7093 566.183 30.4013 565.86 30.4013 565.462C30.4013 565.064 30.7093 564.742 31.0892 564.742Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M63.9563 536.376C64.3294 536.376 64.6318 536.692 64.6318 537.083C64.6318 537.474 64.3294 537.791 63.9563 537.791C63.5832 537.791 63.2808 537.474 63.2808 537.083C63.2808 536.692 63.5832 536.376 63.9563 536.376Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M40.1131 567.039C40.4896 567.039 40.7948 567.359 40.7948 567.753C40.7948 568.147 40.4896 568.467 40.1131 568.467C39.7365 568.467 39.4313 568.147 39.4313 567.753C39.4313 567.359 39.7365 567.039 40.1131 567.039Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M38.9044 441.853C39.2467 441.853 39.5242 442.144 39.5242 442.502C39.5242 442.861 39.2467 443.151 38.9044 443.151C38.5622 443.151 38.2847 442.861 38.2847 442.502C38.2847 442.144 38.5622 441.853 38.9044 441.853Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M47.6153 743.454C47.9576 743.454 48.2351 743.744 48.2351 744.102C48.2351 744.461 47.9576 744.751 47.6153 744.751C47.2731 744.751 46.9956 744.461 46.9956 744.102C46.9956 743.744 47.2731 743.454 47.6153 743.454Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M53.9607 725.561C54.303 725.561 54.5804 725.851 54.5804 726.21C54.5804 726.568 54.303 726.859 53.9607 726.859C53.6185 726.859 53.341 726.568 53.341 726.21C53.341 725.851 53.6185 725.561 53.9607 725.561Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M89.622 709.317C89.9643 709.317 90.2418 709.607 90.2418 709.966C90.2418 710.324 89.9643 710.615 89.622 710.615C89.2798 710.615 89.0023 710.324 89.0023 709.966C89.0023 709.607 89.2798 709.317 89.622 709.317Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M215.801 791.963C216.143 791.963 216.42 792.254 216.42 792.612C216.42 792.971 216.143 793.261 215.801 793.261C215.458 793.261 215.181 792.971 215.181 792.612C215.181 792.254 215.458 791.963 215.801 791.963Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M298.892 649.178C299.235 649.178 299.512 649.468 299.512 649.827C299.512 650.185 299.235 650.476 298.892 650.476C298.55 650.476 298.273 650.185 298.273 649.827C298.273 649.468 298.55 649.178 298.892 649.178Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M39.4802 645.13C39.8225 645.13 40.0999 645.42 40.0999 645.779C40.0999 646.137 39.8225 646.428 39.4802 646.428C39.1379 646.428 38.8605 646.137 38.8605 645.779C38.8605 645.42 39.1379 645.13 39.4802 645.13Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M268.229 671.27C268.572 671.27 268.849 671.56 268.849 671.919C268.849 672.277 268.572 672.568 268.229 672.568C267.887 672.568 267.61 672.277 267.61 671.919C267.61 671.56 267.887 671.27 268.229 671.27Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M222.834 739.546C223.177 739.546 223.454 739.836 223.454 740.195C223.454 740.553 223.177 740.844 222.834 740.844C222.492 740.844 222.215 740.553 222.215 740.195C222.215 739.836 222.492 739.546 222.834 739.546Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M109.344 793.177C109.687 793.177 109.964 793.468 109.964 793.826C109.964 794.185 109.687 794.475 109.344 794.475C109.002 794.475 108.725 794.185 108.725 793.826C108.725 793.468 109.002 793.177 109.344 793.177Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M119.998 769.562C120.357 769.562 120.649 769.867 120.649 770.243C120.649 770.62 120.357 770.925 119.998 770.925C119.639 770.925 119.347 770.62 119.347 770.243C119.347 769.867 119.639 769.562 119.998 769.562Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M52.3613 686.117C52.7036 686.117 52.9811 686.408 52.9811 686.766C52.9811 687.124 52.7036 687.415 52.3613 687.415C52.019 687.415 51.7416 687.124 51.7416 686.766C51.7416 686.408 52.019 686.117 52.3613 686.117Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M252.397 753.791C252.74 753.791 253.017 754.082 253.017 754.44C253.017 754.799 252.74 755.089 252.397 755.089C252.055 755.089 251.778 754.799 251.778 754.44C251.778 754.082 252.055 753.791 252.397 753.791Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M342.29 571.219C342.632 571.219 342.91 571.509 342.91 571.868C342.91 572.226 342.632 572.517 342.29 572.517C341.948 572.517 341.67 572.226 341.67 571.868C341.67 571.509 341.948 571.219 342.29 571.219Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M342.056 567.609C342.398 567.609 342.676 567.9 342.676 568.258C342.676 568.617 342.398 568.907 342.056 568.907C341.714 568.907 341.436 568.617 341.436 568.258C341.436 567.9 341.714 567.609 342.056 567.609Z"
          fill="hsl(var(--color-accent))" />
        <path
          d="M88.8053 440.283C89.151 440.283 89.4312 440.576 89.4312 440.938C89.4312 441.3 89.151 441.594 88.8053 441.594C88.4596 441.594 88.1793 441.3 88.1793 440.938C88.1793 440.576 88.4596 440.283 88.8053 440.283Z"
          fill="hsl(var(--color-accent))" />
      </g>
    </g>
  </g>
  <defs>
    <filter
      id="filter0_f_1179_3871"
      x="-200"
      y="300.472"
      width="775"
      height="1008.36"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feGaussianBlur stdDeviation="100" result="effect1_foregroundBlur_1179_3871" />
    </filter>
    <filter
      id="filter1_f_1179_3871"
      x="-385.636"
      y="366.954"
      width="1141.17"
      height="496.897"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_1179_3871" />
    </filter>
    <linearGradient
      id="paint0_linear_1179_3871"
      x1="285.889"
      y1="522.078"
      x2="-67.636"
      y2="498.164"
      gradientUnits="userSpaceOnUse">
      <stop offset="0.31651" stop-color="#D9D9D9" />
      <stop offset="0.93071" stop-color="#D9D9D9" stop-opacity="0" />
    </linearGradient>
    <clipPath id="clip0_1179_3871">
      <rect width="375" height="809" fill="white" />
    </clipPath>
  </defs>
</svg>
